// frontend/src/contexts/ClientAuthContext.js
import React, { createContext, useState, useContext, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { clientLogin as apiLogin, clientLogout as apiLogout } from '../services/clientApi';

const ClientAuthContext = createContext(null);

export const useClientAuth = () => {
  const context = useContext(ClientAuthContext);
  if (!context) {
    throw new Error('useClientAuth must be used within ClientAuthProvider');
  }
  return context;
};

export const ClientAuthProvider = ({ children }) => {
  const navigate = useNavigate();
  const [client, setClient] = useState(null);
  const [loading, setLoading] = useState(true);
  const [packages, setPackages] = useState([]);

  useEffect(() => {
    // Vérifier si le client est déjà connecté
    const token = localStorage.getItem('client_access_token');
    const savedClient = localStorage.getItem('client_data');
    
    if (token && savedClient) {
      try {
        const clientData = JSON.parse(savedClient);
        setClient(clientData);
        setPackages(clientData.packages || []);
      } catch (e) {
        localStorage.removeItem('client_access_token');
        localStorage.removeItem('client_refresh_token');
        localStorage.removeItem('client_data');
      }
    }
    setLoading(false);
  }, []);

  const login = async (email, password) => {
    const response = await apiLogin(email, password);
    const { access_token, refresh_token, client: clientData } = response.data;
    
    localStorage.setItem('client_access_token', access_token);
    localStorage.setItem('client_refresh_token', refresh_token);
    localStorage.setItem('client_data', JSON.stringify(clientData));
    
    setClient(clientData);
    setPackages(clientData.packages || []);
    
    return clientData;
  };

  const logout = async () => {
    try {
      await apiLogout();
    } catch (e) {
      console.error('Logout error:', e);
    }
    localStorage.removeItem('client_access_token');
    localStorage.removeItem('client_refresh_token');
    localStorage.removeItem('client_data');
    setClient(null);
    setPackages([]);
    // Rediriger vers la page d'accueil (landing page)
    navigate('/');
  };

  const hasPackage = (packageName) => {
    return packages.some(p => p.name === packageName || p === packageName);
  };

  return (
    <ClientAuthContext.Provider value={{
      client,
      loading,
      packages,
      hasPackage,
      login,
      logout,
      isAuthenticated: !!client
    }}>
      {children}
    </ClientAuthContext.Provider>
  );
};